import axios from 'axios';
import { serverUrl } from "../config/app";
import i18next from "../lang/i18next";

axios.defaults.headers.common['Accept-Language'] = i18next.language;

export const fetchData = async url => {
   return new Promise((resolve, reject) => {
      axios
      .get(url)
      .then(response => {
         resolve(response.data);
      })
      .catch(error => {
         reject(error);
      });
   });
};

export const getServerMapData = async () => {
   try {
      return await fetchData(serverUrl);
   } catch (error) {
      const serverData = await import('../data/server.json');
      return serverData.default;
   }
};